import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.packageDetails || initialState;

export const selectPackage = createSelector(
  [selectDomain],
  (state) => state.package
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectTestCategories = createSelector([selectDomain], (state) => {
  const packageData = state.package;
  const tests = packageData?.tests || [];
  const testCategories = {};
  tests.forEach((test) => {
    const testCategory = test.test.testCategory;
    if (!testCategories[testCategory._id]) {
      testCategories[testCategory._id] = {
        _id: testCategory._id,
        name: testCategory.name,
        tests: [],
      };
    }
    let testObj = { ...test.test };
    testObj.price = test.price;

    testCategories[testCategory._id].tests.push(testObj);
  });
  return testCategories;
});
